import React from 'react';

/**
 * Spinner di caricamento utilizzato in tutta l'applicazione.
 * Mostra un cerchio rotante con testo "Caricamento...".
 */
const LoadingSpinner: React.FC = () => {
  return (
    <>
      <style>{`
        @keyframes vspot-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e5e7eb',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'vspot-spin 0.8s linear infinite',
          }}
        />
        <span style={{ marginLeft: '0.75rem', color: '#6b7280' }}>Caricamento...</span>
      </div>
    </>
  );
};

export default LoadingSpinner;